import type { ApiServiceOrder } from '#api/tourservice/model/types.ts';
import type { ServiceOrder } from '#domain/model/ServiceOrder.ts';

export const mapServiceOrder = (order: ApiServiceOrder): ServiceOrder => ({
    id: order.id,
    external_id: order.external_id,
    order: order.order,
    category: order.category ?? undefined,
    company: order.company ?? undefined,
    secondary_reference_id: order.secondary_reference_id,
    note: order.note,
});

export const mapServiceOrders = (stops: ApiServiceOrder[]): ServiceOrder[] => stops.map(mapServiceOrder);
